class UserTypes{
    constructor(){
        this.SubAdmin = "SubAdmin"
        this.Admin = "Admin";
        this.AppointmentEmployee = "AppointmentEmployee";
        this.AccountingEmployee = "AccountingEmployee";
        this.Patient = "Patient";
        this.Therapist = "Therapist";
        this.AssessmentTherapist = "AssessmentTherapist";
        this.UnAssigned = "UnAssigned";
        this.FloorManager = "FloorManager";

    }

}

export default UserTypes;
